import { clsx } from 'clsx';
import { useToast } from '../../hooks/use-toast';
import styles from './toast.module.css';

export const Toast = () => {
	const { isOpen, message } = useToast();

	return (
		<div className={clsx(styles.toastWrapper, { [styles.open]: isOpen })}>
			<p>{message}</p>
		</div>
	);
};
